const USER_MANAGEMENT_EVENTS = {
  REVOKE_INVITATION: 'REVOKE_INVITATION',
  DEACTIVATE: 'DEACTIVATE',
  REACTIVATE: 'REACTIVATE',
  CHANGE_ROLE: 'CHANGE_ROLE',
  INVITE: 'INVITE',
  DISABLE_MFA: 'DISABLE_MFA',
};

export default USER_MANAGEMENT_EVENTS;
